var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-cc-shift4',{ref:"shift4",attrs:{"amount":_vm.amount,"message":_vm.message,"method":_vm.method},on:{"token":_vm.token,"error":_vm.error}})
}
var staticRenderFns = []

export { render, staticRenderFns }